import { Button } from '@/shared/components/ui/button'
import { useUserContext } from '@/shared/contexts/userContext'
import React from 'react'
import { EmptyStateProps } from './types'

export const EmptyState: React.FC<EmptyStateProps> = ({
  onNavigateToDashboard,
}) => {
  const { user } = useUserContext()

  return (
    <div className="flex flex-col items-center justify-center py-16">
      {/* Empty State Card */}
      <div className="mb-8 flex flex-col items-center">
        {/* No Playbooks Image */}
        <div className="mb-6 flex items-center justify-center">
          <img
            src="/images/no-playbooks.png"
            alt="No playbooks available"
            className="h-32 w-auto"
          />
        </div>

        {/* Empty State Text */}
        <h3 className="mb-2 text-lg font-medium text-gray-700">
          No playbooks available
        </h3>
        {user && (
          <>
            <p className="mb-6 max-w-md text-center text-sm text-gray-500">
              Get started by creating your first AI playbook to transform
              business challenges into victories
            </p>

            <Button
              onClick={onNavigateToDashboard}
              className="rounded-lg px-6 py-2 font-medium"
            >
              Create Your First Playbook
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
